import { Box, Grid } from "@material-ui/core";
import useText from "constants/text";
import ParcelCard from "domains/Request/component/ParcelCard";
import { AddRequestInput } from "generated/graphql";
import { HandlersIcon, ProductTypeIcon } from "icons";
import { useDetailsStyles } from "../../RightSideDetails";

interface DetailsInfosProps {
  requestToDisplay?: AddRequestInput;
}

const DetailsInfos = ({ requestToDisplay }: DetailsInfosProps) => {
  const { text } = useText();
  const styles = useDetailsStyles();
  return (
    <>
      <Box className={styles.details}>
        {text.all.details} <hr className={styles.hr} />
      </Box>
      <Grid className={styles.parcelCardGrid}>
        <Box className={styles.marge}>
          <ParcelCard
            icon={<ProductTypeIcon />}
            title="Dispatchers"
            value={requestToDisplay?.dispatcher?.numberOfDispatcher}
          />
        </Box>
        <Box className={styles.marge}>
          <ParcelCard icon={<HandlersIcon />} title="handlers" value={requestToDisplay?.handler?.numberOfHandler} />
        </Box>
      </Grid>

      {requestToDisplay?.additionnalInfos && (
        <Grid container className={styles.additionalInfos}>
          <Box className={styles.details}>
            {text.all.additional_infos} <hr className={styles.hr4} />
          </Box>
          <br />
          <Grid item xs={12} className={styles.additionalInfo}>
            <p>{requestToDisplay?.additionnalInfos}</p>
          </Grid>
        </Grid>
      )}
    </>
  );
};

export default DetailsInfos;
